import React from 'react';
import { Box, Typography, colors, useMediaQuery } from '@mui/material';
import { MITStatusChip } from '../StatusChip/MITStatusChip';
import { getMITStatusBackgroundColor } from '../../constants';
import { formatCurrency } from '../../../../util/formatters';
import { MIT } from '../../../../store/modules/mit/types';
import { AcceptedCurrency } from '../../../../store/modules/merchant/types';
import appTheme from '../../../../styles/themes/theme';

export const MITSummary = ({ mit, currency }: { mit: MIT; currency: AcceptedCurrency }) => {
  const isMobile = useMediaQuery(appTheme.breakpoints.down('sm'));
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: isMobile ? 1.5 : 2.5,
        borderRadius: '24px',
        backgroundColor: getMITStatusBackgroundColor(mit.status),
      }}
    >
      <MITStatusChip status={mit.status} size="medium" />
      <Typography
        sx={{
          fontSize: 32,
          lineHeight: '36px',
          fontWeight: 600,
          color: colors.common.black,
          marginTop: isMobile ? 0.5 : 1,
        }}
      >
        {formatCurrency(mit.amount / 100, mit.currencyCode || currency?.code || 'USD')}
      </Typography>
    </Box>
  );
};
